import { Model, Attr } from 'spraypaint';
import type { PeriodType } from '@/modules/common/utils/type.utils';
import ApplicationRecord from './ApplicationRecord';

@Model()
class PayslipReminderOrder extends ApplicationRecord {
  static jsonapiType = 'payslip_reminder_orders';

  @Attr() payslipPeriod!: PeriodType;
  @Attr() legalEntityIds!: number[];
  @Attr({ persist: false }) userId!: number;
  @Attr({ persist: false }) remindersCount!: number;
  @Attr({ persist: false }) createdAt!: string;
  @Attr({ persist: false }) updatedAt!: string;
  @Attr({ persist: false }) legalEntityNames!: string[];
  @Attr({ persist: false }) userFullName!: string;
}

export default PayslipReminderOrder;
